/* 51Talk的语法学习页面*/
/*  Author: wanfengren */
/* create: 2019/08/16 */
<template>
<div class="flex-center flex-column mainbody" id="textDiv">
  <!-- 通用介绍 -->
  <div class="header-panel">
    <div class="header-title" v-bind:style="{fontSize: changeTitleFontSize() + 'px'}"><span>{{Data.grammar_level}}</span></div>
  </div>

  <!-- <div class="headertitle" v-bind:style="{fontSize: changeTitleFontSize() + 'px'}">{{Data.title}}</p></div> -->

  <div v-if="Data.picture_link.length > 0 | Data.media_link.length > 0 | Data.video_link.length > 0" class="resource-content intro" >
    <img class="parent_img" :src="Data.picture_link" v-if="Data.picture_link.length > 0">
    <!-- 语法解释 -->
    <!-- <div class="maintext" v-if="Data.desc!='1'"> -->
    <div class="maintext" v-if="Data.desc.length< 2" >
      <div class="flex-row-left" v-html="addDiv(Data.desc)"></div>
    </div>
    <audio id="media_link" class="audio_dailyword" controls="controls" :src="Data.media_link" v-if="Data.media_link.length > 0">
     {{ lang.audio_tips }}
     </audio>

     <div class="header-panel" v-if="Data.video_link.length > 0">
       <div class="header-title"><span>{{ lang.grammer_video }}</span></div>
    </div>

   <div class="flex-row-center" v-if="Data.video_link.length > 0">
       <iframe id="video_link" class="video_iframe" style="z-index:1;"
       :src="Data.video_link" allowfullscreen="" frameborder="0"
       :width="MAXWIDTH"
       :height="MAXHEIGHT"
       ></iframe>
   </div>

  </div>

  <!-- 其他异常情况处理 -->
  <div v-else class="maintext">
    <img class="parent_img" src="../../../static/images/sadtips.png">
    <div class="flex-row-left" v-html="addDiv(Data.tips)"></div>
  </div>

</div>
</template>

<script>
import BaseVue from '@/components/BaseVue'

export default {
  name: 'GrammarTemplate',
  extends: BaseVue,
  data() {
    return {
      Data: {
        id: 86,
        grammar_level: '',
        grammar_level_en: 'grammar',
        picture_link: '',
        video_link: '',
        video_link_li: [],
        media_link: '',
        desc: '',
        url_params: '',
        tips: ''
      }
    }
  },
  computed: {
    tailUrl: function() {
      return this.url_params === '' ? '' : '?' + this.url_params
    }
  },
  created: async function() {
    let data_id = this.$route.params.id
    // let url = this.APIHOST_ORIGINAL + 'grammar_level/' + data_id + '?format=json&cipher=0'  //test can use the cipher=0 para
    let url = this.GATEWAY_ORIGINAL + 'bigdata/unit_knowledge/query_grammar_level?id=' + data_id
    this.url_params = this.$route.fullPath.split('?')[1]
    let that = this;
    await this.getLang()
    document.title = this.lang.GrammarTemplateTitle
    this.Data.grammar_level = this.lang.grammer_study
    this.Data.tips = this.lang.grammer_tips_1
    this.queryData(url, function(data) {
      that.Data = data
      // 多个视频时，每个都需处理url
      console.log('video_link:'+ that.Data.video_link)
      if (that.Data.video_link){
        // for(i=0 ; i< that.Data.video_link.split(',').length ; i++){
        //   tmp[i] = that.resetVideoSize(that.Data.video_link.split(',')[i])
        // }
        that.Data.video_link = that.resetVideoSize(that.Data.video_link.split(',')[0])
      }
      that.Data.tips = that.lang.grammer_tips_1
    })
  },
  methods: {
    changeTitleFontSize: function(){
      if (window.innerWidth >500) return 20
      return  parseInt(375 / (12+this.Data.grammar_level.toString().length))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/resource/Grammar.vue